import React from 'react'
import { Text } from '../../atoms'
import { HighlightEffect } from '../../../enums/KeyboardControls'
import { useKeyboardControls } from '../../../contexts/KeyboardControlsContext'
import ControlHighlight from '../../molecules/KeyboardControls/ControlHighlight'
import KeyboardControl from '../../molecules/KeyboardControls/KeyboardControl'
import { DASHBOARD_RESKIN_MENU_LINK_CLASS } from '../../userAdmin/dashboardReskinTiles'

interface OptionProps {
  text: string
  onClick?: () => void
  focusableElement: string
  isReskin?: boolean
}

const Option: React.FC<OptionProps> = ({ text, focusableElement = '', onClick, isReskin = false }) => {
  const keyboardControls = useKeyboardControls()
  return (
    <ControlHighlight
      active={keyboardControls.isEnabled && keyboardControls.isElementFocused(focusableElement)}
      highlightEffect={HighlightEffect.LinkUnderline}
      data-testid={`highlight-${focusableElement}`}
    >
      <KeyboardControl>
        <button
          id={focusableElement}
          className={isReskin
            ? DASHBOARD_RESKIN_MENU_LINK_CLASS
            : 'option underline text-[26px] text-dopage-lightGreen cursor-pointer'}
          onClick={onClick}
        >
          {isReskin ? text : <Text text={text} className='font-white' />}
        </button>
      </KeyboardControl>
    </ControlHighlight>
  )
}

export default Option
